<sf-card>
    <ng-container [formGroup]="form">
        <div class="row gx-5 px-3 py-2">
            <div class="col-md-6 border-end border-end-md-1">
                <h5>Customer Details</h5>
                <sf-input label="Customer" inputId="customer" formControlName="customerName"></sf-input>
                <sf-input label="Email" inputId="email" formControlName="emailAddress"></sf-input>
                @if (existingWorkAddress()) {
                    <sf-input-textarea
                        label="Work Address"
                        inputId="workAddress"
                        [rows]="2"
                        [maxLength]="1000"
                        formControlName="workAddress" />
                } @else {
                    <hr />
                    <sf-postcode-lookup
                        label="Postcode"
                        inputId="postcode"
                        formControlName="postcode"
                        (onAddressChange)="selectAddress($event)" />
                    <sf-input label="Address Line 1" inputId="addressLine1" formControlName="addressLine1"></sf-input>
                    <sf-input label="Address Line 2" inputId="addressLine2" formControlName="addressLine2"></sf-input>
                    <sf-input label="Town" inputId="town" formControlName="town"></sf-input>
                    <sf-input label="County" inputId="county" formControlName="county"></sf-input>
                }
            </div>
            <div class="col-md-6">
                <h5>Job Details</h5>

                <sf-label
                    description="select a predefined job template to prefill the job description"
                    for="jobType"
                    label="Job template"></sf-label>
                <ng-select
                    id="jobType"
                    placeholder="Select template"
                    [items]="smartQuoteTemplates()"
                    bindValue="id"
                    bindLabel="name"
                    (change)="onJobTypeChange($event)">
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                        <div class="card">
                            <div class="card-body">
                                <p class="fw-bold mb-1">{{ item.name }}</p>
                                <p class="mb-0" [innerText]="item.description"></p>
                            </div>
                        </div> </ng-template
                ></ng-select>
                <p class="small text-muted">
                    Select an item from the dropdown above to pre-populate the job description.
                </p>

                <sf-input-textarea
                    description="Shown to the customer on the acceptance page"
                    label="Job Description"
                    inputId="notes"
                    [maxLength]="2000"
                    [rows]="3"
                    formControlName="notes"></sf-input-textarea>
                <sf-input-textarea
                    description="Internal notes, not shown to the customer"
                    label="Staff Notes"
                    inputId="notes"
                    [maxLength]="2000"
                    [rows]="3"
                    formControlName="staffNotes"></sf-input-textarea>
                <sf-input-textarea
                    description="Internal notes, not shown to the customer, visible to engineer on app"
                    label="Engineer Notes"
                    inputId="notes"
                    [maxLength]="2000"
                    [rows]="3"
                    formControlName="engineerNotes"></sf-input-textarea>
            </div>
        </div>
    </ng-container>
</sf-card>
